export type TransformLabelFunction = (transformedTitle: string) => string

const getPathFromUrl = (url: string): string => url.split(/[?#]/)[0]

export const convertBreadcrumb = (
  title: string,
  toUpperCase: boolean,
  replaceCharacterList: RegExp[],
  transformLabel?: TransformLabelFunction
): string => {
  const transformedTitle = getPathFromUrl(title)

  if (transformLabel) {
    return transformLabel(transformedTitle)
  }

  let result = decodeURI(transformedTitle)

  replaceCharacterList.forEach((char: RegExp) => {
    result = result.replace(char, ' ')
  })

  return toUpperCase ? result.toUpperCase() : result
}
